import { ExternalLinkIcon } from 'lucide-react'

import { useOnboardingStep } from 'components/hooks/employer_onboarding/useOnboardingStep'
import { Button, ButtonLink, CollapsibleContainer, usePageTitle } from 'slab'

import { CenteredLayout } from '../CenteredLayout'

interface EmployeeLandingPageProps {
  assets?: {
    images?: Record<string, string>
  }
}
export function EmployeeLandingPage ({ assets }: EmployeeLandingPageProps) {
  usePageTitle('Welcome to Thatch')
  const { navigateToPreviousStep } = useOnboardingStep()
  const emailInvitationUrl = assets?.images?.['email-invitation'] ?? ''

  return (
    <CenteredLayout verticallyCentered>
      <CenteredLayout.Header
        heading="We're happy to have you here"
        subheading='What best describes you?'
      />
      <CenteredLayout.Container hideCard>
        <div className='space-y-0 [&_.border-gray-400]:border-gray-200 [&_.shadow-md]:shadow-none [&_.has-\[\.trigger:hover\]\:shadow-lg]:hover:shadow-none [&_.text-gray-800]:bg-white [&>*:first-child]:rounded-tl-lg [&>*:first-child]:rounded-tr-lg [&>*:first-child]:rounded-l-none [&>*:first-child]:rounded-r-none [&>*:first-child]:border-b-0 [&>*:last-child]:rounded-bl-lg [&>*:last-child]:rounded-br-lg [&>*:last-child]:rounded-l-none [&>*:last-child]:rounded-r-none [&>*:last-child_.bg-gray-50]:rounded-bl-lg [&>*:last-child_.bg-gray-50]:rounded-br-lg'>
          <CollapsibleContainer
            heading='I need to set up my new Thatch benefits'
            defaultOpen={false}
          >
            <div className='px-12 py-6 bg-gray-50 space-y-4'>
              <p className='heading-sm'>
                Check your inbox for an email like this
              </p>
              <p className='body'>
                You'll need to click the link in your email that your employer sent you in order to create your Thatch account.
              </p>
              <p className='body'>
                Don't have the link? Reach out to your employer and ask them to re-send it!
              </p>
              <img
                src={emailInvitationUrl}
                alt='Email invitation from Thatch to select health benefits'
                className='w-full'
              />

            </div>
          </CollapsibleContainer>
          <CollapsibleContainer
            heading='Sign in to my existing Thatch account'
            defaultOpen={false}
          >
            <div className='px-12 py-6 bg-gray-50'>
              <ButtonLink href='https://app.thatch.com/login' variant='primary' size='large' rightIcon={ExternalLinkIcon}>
                Sign in to Thatch
              </ButtonLink>
            </div>
          </CollapsibleContainer>
        </div>
      </CenteredLayout.Container>
      <CenteredLayout.Buttons>
        <Button
          variant='secondary'
          onClick={navigateToPreviousStep}
        >
          Back
        </Button>
      </CenteredLayout.Buttons>
    </CenteredLayout>
  )
}
